/**
 * ============================================================================
 * MASTER SERVICE: Database Master Service (`tbl_database_master` - Sheet 2)
 * ============================================================================
 * Purpose:
 *   Handles API requests for tenant database tracking, port allocation,
 *   and connection string metadata.
 *
 * Database Scope:
 *   Master Database (`digimaster`)
 * ============================================================================
 */

import { createCrudService } from "../../core/services/crudServiceFactory";

const databaseService = createCrudService("databases");

export default databaseService;
